import getActionsByDocument from '../../../../../components/logs/actions';

const DOCUMENT = 'DIVISION_LOGS_';

export default getActionsByDocument(DOCUMENT);
